import { AssignedEnrichedUserDetailValuesModel } from './assigned-enriched-user-detail-values-model';
import { EnrichedUserDetailsModel } from "./enriched-user-details-model";

export interface EnrichedUserDetailsCollectionModel {
  companyId: string;
  enrichedUserDetails: EnrichedUserDetailsModel[];
  assignedEnrichedUserDetails: AssignedEnrichedUserDetailValuesModel[];
}
